import "./SelfWelcome.scss"
import {Dropdown} from "../Dropdown";
import {useRef, useState} from "react";
import {ReactComponent as Triangle1} from "../../assets/self/triangle1.svg";
import {ReactComponent as Triangle2} from "../../assets/self/triangle2.svg";
import {ReactComponent as Triangle3} from "../../assets/self/triangle3.svg";
import {ReactComponent as Play} from "../../assets/self/play.svg";
import {ReactComponent as Pause} from "../../assets/self/pause.svg";
import heroImage from "../../assets/self/hero-image.png"
import {S, T} from "../Text";
import { Button } from "../Button";
import { useNavigate } from "react-router-dom";

const LENGTHS = [{value: "15", label: "15 seconds"}, {value: "30", label: "30 seconds"}, {value: "60", label: "60 seconds"}]
export const SelfWelcome = (props: {mobile: boolean}) => {
    const [length, setLength] = useState("30")
    const [playing, setPlaying] = useState([0,false])
    const [formHover, setFormHover] = useState(false)
    const playerRef = useRef<HTMLAudioElement>(null)
    const navigate = useNavigate()

    function createProject() {
        navigate(`/sizzl/${length}`)
    }

    function play(sample: number) {
        if (!playerRef.current)
            return
        if (sample === playing[0]) {
            if (playerRef.current.paused) {
                playerRef.current.play().then(() => {setPlaying([sample, true])})
            } else {
                playerRef.current.pause()
                setPlaying([sample, false])
            }
        } else {
            if (!playerRef.current.paused)
                playerRef.current.pause()
            playerRef.current.src = `/audio${sample}.mp3`
            playerRef.current.play().then(() => {setPlaying([sample, true])})
        }
    }

    return <div className={"welcome" + (props.mobile ? " mobile" : "")}>
        <div className="top">
            <Triangle1 className="triangle1"/>
            <img src={heroImage} className="self-hero" alt="hero"/>
            <T name="title"/>
            <T name="subtitle"/>
            <div className="form" onMouseEnter={() => setFormHover(true)} onMouseLeave={() => setFormHover(false)}>
                <T name="form-title"/>
                <T name="form-subtitle"/>
                <Dropdown options={LENGTHS} current={length} onChange={setLength}/>
                <Button text="Create a Project"
                    bg="none" color={formHover ? "var(--Primary-Black, #000A18)" : "var(--White, #F5FBFC)"}
                    border={formHover ? "2px solid var(--Primary-Black, #000A18)" : "2px solid var(--White, #F5FBFC)"}
                    bgHover={formHover ? "var(--Primary-Black, #000A18)" : "var(--White, #F5FBFC)"}
                    colorHover={formHover ? "var(--White, #F5FBFC)" : "var(--Primary-Black, #000A18)"}
                    onClick={createProject}/>
                <div className="other"><S name="different"/> <S name="tell-us" onClick={() => navigate('/work')}/></div>
            </div>
            <T name="welcome-comment"/>
        </div>
        <div className="bottom">
            <Triangle3 className="triangle3"/>
            <Triangle2 className="triangle2"/>
            <T name="completed"/>
            <T name="specialize"/>
            <div className="samples">
                <div className="sample">{playing[0] === 1 && playing[1] ? <Pause onClick={() => play(1)}/>:<Play onClick={() => play(1)}/>}<span className="text">Manscaped | :30s</span></div>
                <div className="sample">{playing[0] === 2 && playing[1] ? <Pause onClick={() => play(2)}/>:<Play onClick={() => play(2)}/>}<span className="text">NatureMade | :30s</span></div>
                <div className="sample">{playing[0] === 3 && playing[1] ? <Pause onClick={() => play(3)}/>:<Play onClick={() => play(3)}/>}<span className="text">Mint Mobile | :30s</span></div>
            </div>
            <Button text="Create a Project" onClick={createProject} bg="none" color="var(--White, #F5FBFC)" border="2px solid var(--White, #F5FBFC)" bgHover="var(--White, #F5FBFC)" colorHover="var(--Primary-Black, #000A18)"/>
        </div>
        <audio className="audio-player" ref={playerRef}/>
    </div>
}
